<template>
    <div class="ai-tool-page">
        <!-- 引入公共导航栏组件（替换原来的el-menu代码） -->
        <Navbar />
        <!-- 顶部Hero区域（对应第一张图） -->
        <el-row class="hero-section" justify="center" align="middle">
            <canvas ref="particleCanvas" class="particle-canvas"></canvas>
            <!-- 核心内容 -->
            <el-col :span="24" class="hero-content">
                <h1 class="hero-title">您所有的灵感都集中在一个地方</h1>
                <p class="hero-desc">使用土豆AI动画系统，让您的工作流程更加顺畅。</p>
                <el-button type="primary" class="hero-btn" @click="jumpToOfficial()">
                    开启灵感
                </el-button>
            </el-col>
        </el-row>

        <!-- 功能卡片区域（对应第二张图） -->
        <el-container class="section-wrapper">
            <!-- 灵感绘图卡片 -->
            <el-row :gutter="20" class="mb-4">
                <el-col :span="24">
                    <el-card class="feature-card">
                        <el-row :gutter="16" align="middle">
                            <el-col :span="16">
                                <el-image src="/images/home.png" fit="cover" class="feature-img" />
                            </el-col>
                            <el-col :span="8" class="feature-text">
                                <h2>灵感绘图</h2>
                                <p class="text-gray">新创新，新想法，新构思，新视角<br>让AI拓展你的灵感边界</p>
                                <el-button type="default" plain @click="jumpToOfficial()">
                                    开始创作
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>

            <!-- 3D盲盒 + 专属头像卡片 -->
            <el-row :gutter="20" class="mb-4">
                <el-col :span="12">
                    <el-card class="feature-card">
                        <el-image src="/images/home1.png" fit="cover" class="feature-img-sm" />
                        <div class="feature-text-sm">
                            <h2>3D盲盒人物</h2>
                            <p class="text-gray">制作你的专属盲盒人物吧！</p>
                            <el-button type="default" plain @click="jumpToOfficial()">
                                开始创作
                            </el-button>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="feature-card">
                        <el-image src="/images/home2.png" fit="cover" class="feature-img-sm" />
                        <div class="feature-text-sm">
                            <h2>专属人物头像</h2>
                            <p class="text-gray">制作你自己的Q版头像吧！</p>
                            <el-button type="default" plain @click="jumpToOfficial()">
                                开始创作
                            </el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <!-- 超级问答卡片 -->
            <el-row :gutter="20" class="mb-4">
                <el-col :span="24">
                    <el-card class="feature-card">
                        <el-row :gutter="16" align="middle">
                            <el-col :span="8" class="feature-text">
                                <h2>超级问答</h2>
                                <p class="text-gray">你想问的答案都在这里</p>
                                <el-button type="default" plain @click="jumpToOfficial()">
                                    开始问答
                                </el-button>
                            </el-col>
                            <el-col :span="16">
                                <el-image src="/images/home.png" fit="cover" class="feature-img" />
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>
        </el-container>

        <!-- 效率提升区域（对应第三张图） -->
        <el-container class="section-wrapper">
            <el-row class="text-center mb-4">
                <el-col :span="24">
                    <h2 class="section-title">未来已来，创作效率翻倍提升</h2>
                    <p class="text-gray">数字化创造时代的崛起：智能化工具唤醒创造新力</p>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card class="effort-card">
                        <h3>AI 绘图</h3>
                        <p class="text-gray">快速拓展你的灵感边界</p>
                        <el-image src="/images/home3.png" fit="cover" class="effort-img" />
                        <el-button type="default" plain @click="jumpToOfficial()">
                            开始创作
                        </el-button>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="effort-card">
                        <h3>超级问答</h3>
                        <p class="text-gray">快速解答你的疑问答惑</p>
                        <el-image src="/images/home5.png" fit="cover" class="effort-img" />
                        <el-button type="default" plain @click="jumpToOfficial()">
                            开始创作
                        </el-button>
                    </el-card>
                </el-col>
            </el-row>
        </el-container>


        <!-- 底部页脚 -->
        <el-footer class="footer">
            <el-row :gutter="30" justify="center">
                <el-col :span="8" class="footer-col">
                    <h4>联系我们</h4>
                    <!-- <p>微信联系：wsxzs221122</p> -->
                    <p>备注：官网添加</p>
                </el-col>
                <el-col :span="8" class="footer-col">
                    <h4>联系我们</h4>
                    <p><a href="https://ncnhrvty4yc4.feishu.cn/file/NwD2b7LnVorQZXxDoW1c0O4oncd?from=from_copylink"
                            class="footer-link">隐私条款</a></p>
                    <p><a href="https://ncnhrvty4yc4.feishu.cn/file/NwD2b7LnVorQZXxDoW1c0O4oncd?from=from_copylink"
                            class="footer-link">用户协议</a></p>
                    <p><a href="https://ncnhrvty4yc4.feishu.cn/file/IwQHbbIqooH4hSx5rMLc0alCnmg?from=from_copylink"
                            class="footer-link">会员协议</a></p>
                </el-col>
                <el-col :span="8" class="footer-col">
                    <h4>官方微信群</h4>
                    <div class="footer-qr-code">
                        <!-- <el-image src="/images/weixin-mp.png" fit="cover" class="qr-code" /> -->
                        <ul class="group-list">
                            <li> ·群内会不定时同步最新学习资料</li>
                            <li> ·不定时会员兑换码抽奖</li>
                            <li> ·限时提供优先内部测试名额和免费会员邀请码</li>
                        </ul>
                    </div>
                </el-col>
            </el-row>
            <!-- <el-row class="copyright">
                <el-col :span="24" class="text-center">
                    <p>版权所有：韶关灵创科技有限公司
                        备案信息：2025 © 灵创 | 备案/许可证编号为：
                        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer"
                            style="color: #87CEFA;">粤ICP备2025373993号</a>
                    </p>
                </el-col>
            </el-row> -->
        </el-footer>

    </div>
</template>

<script setup>
// 放在<script setup>顶部，优先执行（迁移原生主题初始化逻辑）
; (function () {
    const el = document.querySelector('body')
    // 若localStorage中无THEME，默认设为'dark'
    const theme = localStorage.getItem('THEME') ?? 'dark'
    el.setAttribute('class', theme)
    localStorage.setItem('THEME', theme) // 写入localStorage，确保getTheme()能获取到
    const html = document.documentElement
    function setFont() {
        const cliWidth = html.clientWidth
        if (cliWidth > 1920) {
            html.style.fontSize = '16px'
            return
        }
        html.style.fontSize =
            (16 * (cliWidth / 1920) < 10 ? 10 : 16 * (cliWidth / 1920)) + 'px'
    }
    setFont()
    window.onresize = function () {
        setFont()
    }
})()
import { ref, onMounted, onUnmounted } from 'vue';
import { ElRow, ElCol, ElCard, ElButton, ElImage, ElContainer, ElFooter } from 'element-plus';
import Navbar from './Navbar.vue';
import { useRouter } from 'vue-router' // 导入 useRouter 钩子
// 初始化路由实例
const router = useRouter();

const jumpToOfficial = () => {
    router.push('/official');
};

// 粒子特效核心变量
const particleCanvas = ref(null); // Canvas元素引用
let canvasCtx = null; // Canvas上下文
let animationFrameId = null; // 动画帧ID（用于销毁时取消）
let vars = {}; // 粒子特效核心配置对象（对应原生代码中的vars）

// ===================== 复刻原生工具函数（完全保留原生逻辑） =====================
function project3D(x, y, z, vars) {
    var p, d;
    x -= vars.camX;
    y -= vars.camY - 8;
    z -= vars.camZ;
    p = Math.atan2(x, z);
    d = Math.sqrt(x * x + z * z);
    x = Math.sin(p - vars.yaw) * d;
    z = Math.cos(p - vars.yaw) * d;
    p = Math.atan2(y, z);
    d = Math.sqrt(y * y + z * z);
    y = Math.sin(p - vars.pitch) * d;
    z = Math.cos(p - vars.pitch) * d;
    var rx1 = -1000;
    var ry1 = 1;
    var rx2 = 1000;
    var ry2 = 1;
    var rx3 = 0;
    var ry3 = 0;
    var rx4 = x;
    var ry4 = z;
    var uc = (ry4 - ry3) * (rx2 - rx1) - (rx4 - rx3) * (ry2 - ry1);
    var ua = ((rx4 - rx3) * (ry1 - ry3) - (ry4 - ry3) * (rx1 - rx3)) / uc;
    var ub = ((rx2 - rx1) * (ry1 - ry3) - (ry2 - ry1) * (rx1 - rx3)) / uc;
    if (!z) z = 0.000000001;
    if (ua > 0 && ua < 1 && ub > 0 && ub < 1) {
        return {
            x: vars.cx + (rx1 + ua * (rx2 - rx1)) * vars.scale,
            y: vars.cy + (y / z) * vars.scale,
            d: x * x + y * y + z * z,
        };
    } else {
        return { d: -1 };
    }
}

function elevation(x, y, z) {
    var dist = Math.sqrt(x * x + y * y + z * z);
    if (dist && z / dist >= -1 && z / dist <= 1) return Math.acos(z / dist);
    return 0.00000001;
}

function rgb(col) {
    col += 0.000001;
    var r = parseInt((0.5 + Math.sin(col) * 0.5) * 16);
    var g = parseInt((0.5 + Math.cos(col) * 0.5) * 16);
    var b = parseInt((0.5 - Math.sin(col) * 0.5) * 16);
    return '#' + r.toString(16) + g.toString(16) + b.toString(16);
}

function interpolateColors(RGB1, RGB2, degree) {
    var w2 = degree;
    var w1 = 1 - w2;
    return [
        w1 * RGB1[0] + w2 * RGB2[0],
        w1 * RGB1[1] + w2 * RGB2[1],
        w1 * RGB1[2] + w2 * RGB2[2],
    ];
}

function rgbArray(col) {
    col += 0.000001;
    var r = parseInt((0.5 + Math.sin(col) * 0.5) * 256);
    var g = parseInt((0.5 + Math.cos(col) * 0.5) * 256);
    var b = parseInt((0.5 - Math.sin(col) * 0.5) * 256);
    return [r, g, b];
}

function colorString(arr) {
    var r = parseInt(arr[0]);
    var g = parseInt(arr[1]);
    var b = parseInt(arr[2]);
    return (
        '#' +
        ('0' + r.toString(16)).slice(-2) +
        ('0' + g.toString(16)).slice(-2) +
        ('0' + b.toString(16)).slice(-2)
    );
}

function getTheme() {
    return localStorage.getItem("THEME");
}

// ===================== 复刻原生核心逻辑函数（完全保留原生逻辑） =====================
function process() {
    if (vars.points.length < vars.initParticles)
        for (var i = 0; i < 5; ++i) spawnParticle();
    var p, d, t;

    p = Math.atan2(vars.camX, vars.camZ);
    d = Math.sqrt(vars.camX * vars.camX + vars.camZ * vars.camZ);
    d -= Math.sin(vars.frameNo / 80) / 25;
    t = Math.cos(vars.frameNo / 300) / 165;
    vars.camX = Math.sin(p + t) * d;
    vars.camZ = Math.cos(p + t) * d;
    vars.camY = -Math.sin(vars.frameNo / 220) * 15;
    vars.yaw = Math.PI + p + t;
    vars.pitch = elevation(vars.camX, vars.camZ, vars.camY) - Math.PI / 2;

    var t;
    for (var i = 0; i < vars.points.length; ++i) {
        // 关键：显式声明x、y、z三个变量（用var/let均可，保持原生风格用var）
        var x = vars.points[i].x;
        var y = vars.points[i].y;
        var z = vars.points[i].z;

        d = Math.sqrt(x * x + z * z) / 1.0075;
        t = 0.1 / (1 + (d * d) / 5);
        p = Math.atan2(x, z) + t;
        vars.points[i].x = Math.sin(p) * d;
        vars.points[i].z = Math.cos(p) * d;
        vars.points[i].y +=
            vars.points[i].vy * t * ((Math.sqrt(vars.distributionRadius) - d) * 2);
        if (vars.points[i].y > vars.vortexHeight / 2 || d < 0.25) {
            vars.points.splice(i, 1);
            spawnParticle();
        }
    }
}

function drawFloor() {
    var x, y, z, d, point, a;
    for (var i = -25; i <= 25; i += 1) {
        for (var j = -25; j <= 25; j += 1) {
            x = i * 2;
            z = j * 2;
            y = vars.floor;
            d = Math.sqrt(x * x + z * z);
            point = project3D(x, y - (d * d) / 85, z, vars);
            if (point.d != -1) {
                // 关键：显式声明size变量（第一个循环内）
                var size = 1 + 15000 / (1 + point.d);
                a = 0.15 - Math.pow(d / 50, 4) * 0.15;
                if (a > 0) {
                    vars.ctx.fillStyle = colorString(
                        interpolateColors(
                            rgbArray(d / 26 - vars.frameNo / 40),
                            [0, 128, 32],
                            0.5 + Math.sin(d / 6 - vars.frameNo / 8) / 2
                        )
                    );
                    vars.ctx.globalAlpha = a;
                    vars.ctx.fillRect(
                        point.x - size / 2,
                        point.y - size / 2,
                        size,
                        size
                    );
                }
            }
        }
    }
    vars.ctx.fillStyle = '#82f';
    for (var i = -25; i <= 25; i += 1) {
        for (var j = -25; j <= 25; j += 1) {
            x = i * 2;
            z = j * 2;
            y = -vars.floor;
            d = Math.sqrt(x * x + z * z);
            point = project3D(x, y + (d * d) / 85, z, vars);
            if (point.d != -1) {
                // 关键：显式声明size变量（第二个循环内，保持作用域一致）
                var size = 1 + 15000 / (1 + point.d);
                a = 0.15 - Math.pow(d / 50, 4) * 0.15;
                if (a > 0) {
                    vars.ctx.fillStyle = colorString(
                        interpolateColors(
                            rgbArray(-d / 26 - vars.frameNo / 40),
                            [32, 0, 128],
                            0.5 + Math.sin(-d / 6 - vars.frameNo / 8) / 2
                        )
                    );
                    vars.ctx.globalAlpha = a;
                    vars.ctx.fillRect(
                        point.x - size / 2,
                        point.y - size / 2,
                        size,
                        size
                    );
                }
            }
        }
    }
}

function sortFunction(a, b) {
    return b.dist - a.dist;
}

function draw() {
    var theme = getTheme();
    vars.ctx.globalAlpha = 0.15;
    vars.ctx.fillStyle = theme === "dark" ? '#000' : "#fff";
    vars.ctx.fillRect(0, 0, vars.canvas.width, vars.canvas.height);

    drawFloor();

    // 关键：在顶部变量声明中添加d（与point、x、y等并列）
    var point, x, y, z, a, d;
    for (var i = 0; i < vars.points.length; ++i) {
        x = vars.points[i].x;
        y = vars.points[i].y;
        z = vars.points[i].z;
        point = project3D(x, y, z, vars);
        if (point.d != -1) {
            vars.points[i].dist = point.d;
            var size = 1 + vars.points[i].radius / (1 + point.d);
            d = Math.abs(vars.points[i].y); // 此时d已声明，可正常赋值
            a = 0.8 - Math.pow(d / (vars.vortexHeight / 2), 1000) * 0.8;
            vars.ctx.globalAlpha = a >= 0 && a <= 1 ? a : 0;
            vars.ctx.fillStyle = rgb(vars.points[i].color);
            if (
                point.x > -1 &&
                point.x < vars.canvas.width &&
                point.y > -1 &&
                point.y < vars.canvas.height
            )
                vars.ctx.fillRect(point.x - size / 2, point.y - size / 2, size, size);
        }
    }
    vars.points.sort(sortFunction);
}

function spawnParticle() {
    var p, ls;
    var pt = {}; // 关键：添加pt变量声明（用var/let均可，保持与原生代码风格一致用var）
    p = Math.PI * 2 * Math.random();
    ls = Math.sqrt(Math.random() * vars.distributionRadius);
    pt.x = Math.sin(p) * ls;
    pt.y = -vars.vortexHeight / 2;
    pt.vy = vars.initV / 20 + Math.random() * vars.initV;
    pt.z = Math.cos(p) * ls;
    pt.radius = 200 + 800 * Math.random();
    pt.color = pt.radius / 1000 + vars.frameNo / 250;
    vars.points.push(pt);
}

// ===================== 复刻原生动画循环（适配Vue） =====================
function frame() {
    vars.frameNo++;
    animationFrameId = requestAnimationFrame(frame); // 保存动画帧ID
    process();
    draw();
}

// ===================== 初始化粒子画布（Vue挂载时执行） =====================
function initParticleCanvas() {
    if (!particleCanvas.value) return;

    // 初始化vars对象（对应原生frame函数中的初始配置）
    vars = {
        canvas: particleCanvas.value,
        ctx: particleCanvas.value.getContext('2d'),
        frameNo: 0,
        camX: 0,
        camY: 0,
        camZ: -14,
        pitch: elevation(0, 0, -14) - Math.PI / 2,
        yaw: 0,
        cx: particleCanvas.value.width / 2,
        cy: particleCanvas.value.height / 2,
        bounding: 10,
        scale: 500,
        floor: 26.5,
        points: [],
        initParticles: 700,
        initV: 0.01,
        distributionRadius: 800,
        vortexHeight: 25
    };

    // 保存画布上下文
    canvasCtx = vars.ctx;

    // 启动动画循环
    frame();
}

// ===================== 窗口大小调整处理（适配响应式） =====================
function handleResize() {
    if (!particleCanvas.value) return;
    particleCanvas.value.width = document.body.clientWidth;
    particleCanvas.value.height = document.body.clientHeight;
    vars.cx = particleCanvas.value.width / 2;
    vars.cy = particleCanvas.value.height / 2;
}

// ===================== Vue生命周期钩子（规范管理资源） =====================
onMounted(() => {
    // 初始化Canvas尺寸
    if (particleCanvas.value) {
        particleCanvas.value.width = document.body.clientWidth;
        particleCanvas.value.height = document.body.clientHeight;
    }
    // 初始化粒子特效
    initParticleCanvas();
    // 绑定窗口大小调整事件
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    // 取消动画循环，防止内存泄漏
    cancelAnimationFrame(animationFrameId);
    // 解绑窗口大小调整事件
    window.removeEventListener('resize', handleResize);
});

</script>

<style scoped>
.ai-tool-page {
    background-color: #000 !important;
    background: none;
    color: #fff;
    min-height: 100vh;
}

/* 顶部Hero区域（复刻原生样式） */
.hero-section {
    position: relative;
    height: 100vh;
    padding: 0 20px;
    overflow: hidden;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 1) 100%);

}

/* 3D粒子Canvas样式（完全复刻原生#canvas.astro-SLVZHL3X） */
.particle-canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 100vh;
    width: 100%;
    background-color: #000 !important;
    /* 给Canvas本身也设置暗黑背景，双重保障 */
}

/* 响应式适配（复刻原生媒体查询） */
@media (max-width: 1024px) {
    .particle-canvas {
        height: 70vh;
        width: 100%;
    }

    .hero-section {
        height: 70vh;
    }
}

/* Hero内容（复刻原生字体+布局） */
.hero-content {
    position: relative;
    z-index: 1;
    /* 置于粒子背景上方 */
    text-align: center;
    /* 文本水平居中 */
    max-width: 1280px;
    margin: 0 auto;
    /* 水平居中 */
}

.hero-title {
    font-family: Roboto-Medium, Roboto, "Microsoft YaHei", sans-serif;
    font-size: 4rem;
    font-weight: 600;
    line-height: 6rem;
    letter-spacing: 2px;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 0;
}

.hero-desc {
    padding: 0px 0 3.75rem;
    font-size: 3rem;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 3.25rem;
    text-align: center;
    margin-bottom: 0;
}

.hero-btn {
    width: 15.875rem;
    height: 4.5rem;
    background: linear-gradient(42deg, #e0ce80 0%, #b5c34f 19%, #3cc46d 56%, #56c59f 76%);
    border: none;
    border-radius: 1rem;
    font-size: 1.375rem;
    font-weight: 400;
    color: #ededed;
    letter-spacing: .525rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.5rem auto 0;
    padding: 0;
    cursor: pointer;
}

.hero-btn:hover {
    background: linear-gradient(42deg, #f0dd90 0%, #c5d45f 19%, #4cd47d 56%, #66d5af 76%);
    border: none;
}

/* 响应式字体适配（复刻原生） */
@media (max-width: 1024px) {
    .hero-title {
        font-size: 3rem;
    }

    .hero-desc {
        font-size: 1.5rem;
        line-height: 2.5rem;
    }

    .hero-btn {
        width: 18rem;
        height: 5rem;
        font-size: 2rem;
    }
}

@media (max-width: 768px) {
    .hero-title {
        font-size: 2rem;
        line-height: 3rem;
    }

    .hero-desc {
        font-size: 1rem;
        line-height: 1.8rem;
        padding-bottom: 2rem;
    }

    .hero-btn {
        width: 12rem;
        height: 3rem;
        font-size: 1.2rem;
        letter-spacing: .3rem;
    }
}



.hero-desc {
    font-size: 1.2rem;
    color: #eee;
    margin-bottom: 2rem;
}

.hero-btn {
    background: linear-gradient(42deg, #e0ce80 0%, #3cc46d 56%);
    border: none;
    padding: 0.8rem 2rem;
    font-size: 1.1rem;
}

/* 通用区域容器 */
.section-wrapper {
    max-width: 90%;
    margin: 2rem auto;
    padding: 0 20px;
    display: flex;
    flex-direction: column !important;
}

.mb-4 {
    margin-bottom: 1rem;
}

.text-gray {
    color: #ccc;
    margin: 0.5rem 0 1rem;
}

/* 功能卡片 */
.feature-card {
    background-color: #1a1a1a;
    border: none;
}

.feature-img {
    width: 100%;
    height: 250px;
}

.feature-img-sm {
    width: 100%;
    height: 200px;
    margin-bottom: 1rem;
}

.feature-text {
    padding: 0 1rem;
}

.feature-text-sm {
    text-align: center;
}

/* 效率提升区域 */
.section-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.effort-card {
    background-color: #1a1a1a;
    border: none;
    text-align: center;
    padding: 1rem;
}

.effort-img {
    width: 100%;
    height: 150px;
    margin: 1rem 0;
}

/* 底部页脚 */
.footer {
    background-color: #1c1c1e;
    padding: 3rem 20px 2rem;
    margin-top: 2rem;
}

/* 覆盖底部栏内子组件的默认白色背景 */
::v-deep .footer .el-row,
::v-deep .footer .el-col,
::v-deep .footer .footer-col {
    background-color: inherit !important;
    /* 继承footer的深灰色背景 */
}

/* 确保版权区域背景也同步为深灰色 */
::v-deep .footer .copyright {
    background-color: inherit !important;
}

.footer-col {
    text-align: center;
}

.footer-qr-code {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.footer-link {
    color: #fff;
    text-decoration: none;
}

.footer-link:hover {
    color: #f30;
}

.qr-code {
    width: 100px;
    height: 100px;
    margin: 0 auto 1rem;
}

.group-list {
    text-align: left;
    color: #ccc;
    font-size: 0.9rem;
    padding-left: 20px;
}



.hint {
    color: red;
    font-weight: 700;
    margin-top: 0.5rem;
}

/* 👇 重点：只修改非Hero区域的按钮（精准生效，不影响Hero按钮） */
/* 方法1：通过.section-wrapper父级限定，仅修改功能/效率区域按钮 */
::v-deep .section-wrapper .el-button {
    background: transparent !important;
    /* 无背景色 */
    border: 1px solid #ffffff !important;
    /* 白色边框（可选，去掉则无框） */
    color: #ffffff !important;
    /* 白色文字 */
    border-radius: 30px !important;
    /* 大圆角，可根据需求调整 */
    padding: 8px 24px !important;
    /* 内边距优化 */
    font-size: 0.9rem !important;
    transition: all 0.3s ease !important;
    /* 柔和过渡 */
    /* plain: false !important;  */
}

/* 非Hero按钮hover状态 */
::v-deep .section-wrapper .el-button:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    /* 浅白透明背景反馈 */
    border-color: #e0ce80 !important;
    /* 边框变金色，呼应Hero按钮风格 */
    color: #e0ce80 !important;
    /* 文字变金色 */
}

/* 👇 可选：给非Hero按钮统一添加箭头后缀，无需手动写→ */
::v-deep .section-wrapper .el-button::after {
    content: " →";
    margin-left: 5px;
}


/* 底部页脚核心样式 */
.footer {
    background-color: #1c1c1e;
    padding: 3rem 20px 2rem;
    /* 上下内边距加大，符合截图排版 */
    margin-top: 4rem;
    /* 与上方内容拉开间距 */
    color: #ccc;
}

/* 覆盖Element Plus组件默认样式，确保布局不冲突 */
::v-deep .footer .el-row,
::v-deep .footer .el-col {
    background-color: inherit !important;
    color: inherit !important;
}

/* 页脚列通用样式 */
.footer-col {
    padding: 0 1.5rem;
    /* 列内左右间距，避免内容挤边 */
    font-size: 0.95rem;
    line-height: 1.8;
    /* 行高优化，提升可读性 */
}

/* 左、中列：文本左对齐（匹配截图） */
.footer-col-left,
.footer-col-middle {
    text-align: left;
}

/* 右列：列表排版，左对齐 */
.footer-col-right {
    text-align: left;
}

/* 页脚标题样式（h4） */
.footer-col h4 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
    /* 标题白色突出，匹配截图 */
    margin-bottom: 1.5rem;
    /* 标题与下方内容间距 */
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #333;
    /* 底部浅灰边框，提升层次感 */
}

/* 页脚普通文本（p标签） */
.footer-col p {
    margin-bottom: 0.8rem;
    /* 文本行间距 */
    color: #ccc;
}

/* 页脚链接样式 */
.footer-link {
    color: #ccc;
    text-decoration: none;
    transition: all 0.3s ease;
}

.footer-link:hover {
    color: #e0ce80;
    /* 呼应Hero按钮金色，保持风格统一 */
    text-decoration: underline;
    /*  hover下划线，匹配常规链接交互 */
}

/* 微信群列表样式（核心：匹配截图列表排版） */
.group-list {
    list-style: none;
    /* 去掉默认列表标记（已手动加•） */
    padding: 0;
    margin: 0 0 1.8rem 0;
    /* 列表与二维码间距 */
    color: #ccc;
}

.group-list li {
    margin-bottom: 0.6rem;
    /* 列表项间距 */
    line-height: 1.7;
    font-size: 0.9rem;
}

/* 二维码样式（匹配截图大小和居中） */
.qr-code {
    width: 120px;
    /* 二维码固定大小 */
    height: 120px;
    display: block;
    /* 块级元素，方便居中 */
    margin: 0;
    /* 左对齐，匹配截图排版（如需居中可改为margin: 0 auto;） */
    border: 2px solid #333;
    /* 二维码边框，提升质感 */
    border-radius: 8px;
    /* 轻微圆角，更美观 */
}

/* 版权区域样式 */
.copyright {
    border-top: 1px solid #333;
    color: #999;
    font-size: 1rem;
    display: flex;
    height: 50px;

    .text-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }


}


/* 响应式适配（小屏幕下优化排版） */
@media (max-width: 768px) {
    .footer-col {
        margin-bottom: 2rem;
        /* 小屏幕下列上下排列，增加间距 */
        text-align: center !important;
        /* 小屏幕下居中对齐，提升体验 */
    }

    .qr-code {
        margin: 0 auto;
        /* 小屏幕下二维码居中 */
    }

    .group-list {
        margin-bottom: 1.5rem;
    }
}
</style>
